
const MediaUtil = {
	generateFileName(name, extension) {
		if (extension) {
			if (!extension.startsWith('.')) extension = '.' + extension;
		} else {
			extension = "";
		}
		return StrUtil.urlSlug(name) + extension;
	},

	getSuffix(value) {
		switch (value) {
			case "application/xml":
				return ".xml";
			case "application/json":
				return ".json";
			case "text/css":
				return ".css";
			case "text/plain":
				return ".txt";
			case "text/javascript":
				return ".js";
			default:
				return ".html";
		}
	}
};

window.MediaUtil = MediaUtil;	// Expose as global

export default MediaUtil;